export const WEBSITE_SECTION_OPTIONS = [
  { id: "orderContextBar", label: "Order Context Bar" },
  { id: "hero", label: "Hero" },
  { id: "offerBanner", label: "Offer Banner" },
  { id: "categoryGrid", label: "Categories" },
  { id: "featuredItems", label: "Featured Items" },
  { id: "offerItems", label: "Offer Items" },
  { id: "whatsappFab", label: "WhatsApp Button" },
]

export const WEBSITE_ANIMATION_OPTIONS = {
  pageTransition: [
    { value: "none", label: "None" },
    { value: "fade", label: "Fade" },
    { value: "slide-up", label: "Slide Up" },
  ],
  sectionReveal: [
    { value: "none", label: "None" },
    { value: "fade-up", label: "Fade Up" },
    { value: "fade-in", label: "Fade In" },
  ],
  heroTransition: [
    { value: "none", label: "None" },
    { value: "fade", label: "Fade" },
    { value: "slide", label: "Slide" },
  ],
  easing: [
    { value: "ease", label: "Ease" },
    { value: "ease-out", label: "Ease Out" },
    { value: "ease-in-out", label: "Ease In Out" },
    { value: "spring-soft", label: "Soft Spring" },
  ],
}

export const DEFAULT_WEBSITE_ANIMATIONS = {
  enabled: true,
  respectReducedMotion: true,
  pageTransition: "fade",
  sectionReveal: "fade-up",
  heroTransition: "fade",
  durationMs: 400,
  easing: "ease-out",
}

export const createEmptyLocalized = () => ({ en: "", ar: "" })
